/* ss-sticky-atc.js — thanh ATC dính đáy (mobile).
   Hiện khi nút mua chính đã cuộn khỏi màn hình, ẩn khi nút chính đang thấy.
   Bấm → submit chính form buy box, KHÔNG tự fetch /cart/add.js
   (giữ nguyên luồng cart drawer + sections payload của Dawn). */
(function () {
  'use strict';

  function init(bar) {
    if (bar._ssInit) return;
    bar._ssInit = true;

    var form = document.querySelector(bar.dataset.watch || '#ss-form');
    var mainBtn = form ? form.querySelector('button[type="submit"]') : null;
    var btn = bar.querySelector('[data-submit]');

    if (btn && form) {
      btn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }

    function show(on) {
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }

    if (!mainBtn || !('IntersectionObserver' in window)) {
      show(true);              // không quan sát được thì cứ hiện, còn hơn mất nút
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { show(!e.isIntersecting); });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
    io.observe(mainBtn);

    // Giá đổi theo variant: bám pubsub của Dawn thay vì querySelector cứng,
    // vì DOM trong <product-info> bị thay mới sau mỗi lần đổi variant.
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (event) {
        var v = event && event.data && event.data.variant;
        var out = bar.querySelector('[data-ss-price]');
        if (!v || !out) return;
        btn.disabled = !v.available;
        if (window.Shopify && Shopify.formatMoney) {
          out.textContent = Shopify.formatMoney(v.price, window.money_format);
        }
      });
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-ss-sticky-atc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
